var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-with-banner', {
    attrs: {
      "showFooter": false,
      "isProgressDone": true,
      "fluid": true
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('m-header', {
          attrs: {
            "title": _vm.title,
            "subtitle": _vm.description,
            "breadCrumbs": _vm.breadCrumbs,
            "chips": _vm.chips,
            "actions": _vm.actions
          },
          on: {
            "actionClicked": function actionClicked($event) {
              return $event.exec();
            }
          }
        }), _c('fleet-manager-tree-dialog', {
          ref: "dialog",
          on: {
            "confirm": _vm.load
          }
        }), _c('fleet-cost-center-selector-dialog', {
          ref: "costCenterDialog",
          on: {
            "confirm": _vm.onCostCenterSelected
          }
        }), _c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          attrs: {
            "col": "12",
            "justify": "right",
            "align": "right"
          }
        }, [_c('analytics-date-range-selector-dialog', {
          attrs: {
            "dates": _vm.dates
          },
          on: {
            "setDate": _vm.setDateRange
          }
        })], 1)], 1), _c('v-row', {
          staticClass: "mt-2"
        }, [_c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('v-tabs', {
          model: {
            value: _vm.tab,
            callback: function callback($$v) {
              _vm.tab = $$v;
            },
            expression: "tab"
          }
        }, [_c('v-tab', [_vm._v(" " + _vm._s(_vm.$t("views.report.fleet.FleetAnalyticsView.damageCountTabHeader")) + " ")]), _c('v-tab', [_vm._v(" " + _vm._s(_vm.$t("views.report.fleet.FleetAnalyticsView.damageCostTabHeader")) + " ")])], 1)], 1)], 1), _c('v-tabs-items', {
          model: {
            value: _vm.tab,
            callback: function callback($$v) {
              _vm.tab = $$v;
            },
            expression: "tab"
          }
        }, [_c('v-tab-item', [_c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "12",
            "lg": "12"
          }
        }, [_c('time-series-line-chart-card', {
          attrs: {
            "loading": _vm.dataHandler.reportTrendAnalysis.isLoading,
            "data": _vm.reportTrendData,
            "title": "views.report.fleet.FleetAnalyticsView.trendReports"
          }
        })], 1)], 1), _c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          attrs: {
            "lg": "4",
            "md": "4",
            "sm": "12"
          }
        }, [_c('bar-chart-card', {
          attrs: {
            "loading": _vm.hasStatusValueDistributionData ? _vm.dataHandler.statusValueDistribution.isLoading : _vm.dataHandler.progressStatusDistribution.isLoading,
            "data": _vm.statusDistributionData,
            "kpiGroup": _vm.statusDistributionKpiGroup,
            "sort": false,
            "title": "views.report.fleet.FleetAnalyticsView.statusTypeDistribution"
          }
        })], 1), _c('v-col', {
          attrs: {
            "lg": "4",
            "md": "4",
            "sm": "12"
          }
        }, [_c('pie-chart-card', {
          attrs: {
            "loading": _vm.dataHandler.tripTypeCount.isLoading,
            "data": _vm.tripTypeCountData,
            "kpiGroup": _vm.privateTripKpiGroup,
            "title": "views.report.fleet.FleetAnalyticsView.tripTypeCount"
          }
        })], 1), _c('v-col', {
          attrs: {
            "lg": "4",
            "md": "4",
            "sm": "12"
          }
        }, [_c('pie-chart-card', {
          attrs: {
            "loading": _vm.dataHandler.workshopCompanyDistribution.isLoading,
            "data": _vm.workshopCompanyDistributionData,
            "kpiGroup": _vm.workshopDistributionKpiGroup,
            "title": "views.report.fleet.FleetAnalyticsView.workshopCompanyDistribution"
          }
        })], 1)], 1), _c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          attrs: {
            "lg": "4",
            "md": "4",
            "sm": "12"
          }
        }, [_c('pie-chart-card', {
          attrs: {
            "loading": _vm.dataHandler.coverageTypeCount.isLoading,
            "data": _vm.coverageTypeCountData,
            "title": "views.report.fleet.FleetAnalyticsView.coverageTypeCount"
          }
        })], 1), _c('v-col', {
          attrs: {
            "lg": "4",
            "md": "4",
            "sm": "12"
          }
        }, [_c('pie-chart-card', {
          attrs: {
            "loading": _vm.dataHandler.damageTypeCount.isLoading,
            "data": _vm.damageTypeCountData,
            "title": "views.report.fleet.FleetAnalyticsView.damageTypeCount"
          }
        })], 1), _c('v-col', {
          attrs: {
            "lg": "4",
            "md": "4",
            "sm": "12"
          }
        }, [_c('bar-chart-card', {
          attrs: {
            "loading": _vm.dataHandler.weekdayDistribution.isLoading,
            "data": _vm.weekdayDistributionData,
            "title": "views.report.fleet.FleetAnalyticsView.weekdayDistribution",
            "reverseAxis": true,
            "sort": false
          }
        })], 1)], 1)], 1), _c('v-tab-item', [_c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          attrs: {
            "lg": "4",
            "md": "4",
            "sm": "12"
          }
        }, [_c('pie-chart-card', {
          attrs: {
            "loading": _vm.dataHandler.coverageTypeSubtotal.isLoading,
            "data": _vm.coverageTypeSubtotalData,
            "title": "views.report.fleet.FleetAnalyticsView.coverageTypeSubtotalOutbound"
          }
        })], 1), _c('v-col', {
          attrs: {
            "lg": "4",
            "md": "4",
            "sm": "12"
          }
        }, [_c('pie-chart-card', {
          attrs: {
            "loading": _vm.dataHandler.damageTypeSubtotal.isLoading,
            "data": _vm.damageTypeSubtotalData,
            "title": "views.report.fleet.FleetAnalyticsView.damageTypeSubtotalOutbound"
          }
        })], 1)], 1), _c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          attrs: {
            "lg": "6",
            "md": "6",
            "sm": "12"
          }
        }, [_c('bar-chart-card', {
          attrs: {
            "loading": _vm.dataHandler.topCreditor.isLoading,
            "data": _vm.topCreditorData,
            "title": "views.report.fleet.FleetAnalyticsView.topCreditorDistribution"
          }
        })], 1), _c('v-col', {
          attrs: {
            "lg": "6",
            "md": "6",
            "sm": "12"
          }
        }, [_c('bar-chart-card', {
          attrs: {
            "loading": _vm.dataHandler.topVehicle.isLoading,
            "data": _vm.topVehicleData,
            "title": "views.report.fleet.FleetAnalyticsView.topVehicleDistribution"
          }
        })], 1)], 1), _c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, _vm._l(_vm.coverageSubtotalDeductibleData, function (c) {
          return _c('v-col', {
            key: c.coverageType,
            attrs: {
              "cols": "12",
              "md": "6",
              "lg": "6"
            }
          }, [_c('bar-chart-card', {
            attrs: {
              "loading": _vm.dataHandler.coverageSubtotalDeductible.isLoading,
              "data": c.data,
              "title": "".concat(_vm.$t('views.report.fleet.FleetAnalyticsView.coverageSubtotalDeductible'), ": ").concat(_vm.$t("enums.CoverageTypeEnum.".concat(c.coverageType))),
              "reverseAxis": true,
              "sort": false
            }
          })], 1);
        }), 1)], 1)], 1)];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }